import { render } from "./ManufacturerMainList.vue?vue&type=template&id=84609bfa"
import script from "./ManufacturerMainList.vue?vue&type=script&lang=js"
export * from "./ManufacturerMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__